import { render, staticRenderFns } from "./contactsTable.vue?vue&type=template&id=4dda240a&scoped=true"
import script from "./contactsTable.vue?vue&type=script&lang=js"
export * from "./contactsTable.vue?vue&type=script&lang=js"
import style0 from "./contactsTable.vue?vue&type=style&index=0&id=4dda240a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4dda240a",
  null
  
)

export default component.exports